






























































































































































































import Vue from "vue";
import ListItemCmp from "./ListItemCmp.vue";
import {
  ref,
  Ref,
  computed,
  onMounted,
  onBeforeUnmount,
  watch,
} from "@vue/composition-api";

import { onKey, remToPx } from "@/common/dom.functions";
import { emptyFn, clone, isNotEmpty } from "../../fp";
import {
  POPULATION_TYPE,
  PopulationTypeHelper,
  InformationTypeTree,
} from "../../common/models";
import { UseEntities } from "../../common/composition/entities";
import { EventBus } from "@/eventbus";
import { SharedState } from "@/common/state";
import isEmpty from "lodash.isempty";
import ThemeImg from "@/components/ThemeImg.vue";
import VScroller from "../table/VScroller.vue";
import InfoTypeDetailsTree from "../InfoTypeDetailsTree.vue";
import ContextLabelsSelection from "../filters-bar/ContextLabelsSelection.vue";
interface ListItem {
  id: number | string;
  name: string;
  checked: boolean;
  isPremium?: boolean;
  premiumFeature?: string;
}

export default Vue.extend({
  components: {
    ThemeImg,
    VScroller,
    ListItemCmp,
    InfoTypeDetailsTree,
    ContextLabelsSelection,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disableSearch: {
      type: Boolean,
      default: false,
    },
    hasRightContainer: {
      type: Boolean,
      default: false,
    },
    singleSelection: {
      type: Boolean,
      default: false,
    },
    population: {
      type: String,
      default: POPULATION_TYPE.FOLDER,
    },
    excludeFolderLabelType: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const row_height = ref(remToPx(2.5));
    const population = computed(() => props.population as POPULATION_TYPE);
    const {
      displayItems,
      isLoading,
      loadMoreItems,
      query,
      isSearching,
      changeEntity,
    } = UseEntities({ population: props.population as POPULATION_TYPE });

    const local_info_types: Ref<InformationTypeTree[]> = ref([]);
    const selected_info_types: Ref<Record<string, boolean>> = ref({});
    const is_tree_loading = ref(false);
    const has_loaded_label_tree = ref(false);

    // Utility to defer work to avoid blocking UI
    const run_when_idle = (cb: () => void) => {
      if (typeof window !== "undefined" && "requestIdleCallback" in window) {
        // @ts-ignore
        window.requestIdleCallback(cb);
      } else {
        setTimeout(cb, 0);
      }
    };

    const filter_out_folder_label_type = (
      items: InformationTypeTree[]
    ): InformationTypeTree[] => {
      return items
        .filter((item: any) => item.labelType !== "Folder")
        .map((item) => {
          if (item.nested && item.nested.length > 0) {
            return {
              ...item,
              nested: filter_out_folder_label_type(item.nested),
            };
          }
          return item;
        });
    };

    const load_label_tree = () => {
      is_tree_loading.value = true;
      run_when_idle(() => {
        if (!has_loaded_label_tree.value) {
          const labels_tree = SharedState.info_types_tree.value
            .filter((d) => d.id !== SharedState.default_label_id.value)
            .map((l) => {
              return {
                ...l,
                checked: false,
              };
            });
          local_info_types.value = props.excludeFolderLabelType
            ? filter_out_folder_label_type(labels_tree)
            : labels_tree;
          has_loaded_label_tree.value = true;
        }
        is_tree_loading.value = false;
      });
    };

    const on_info_type_checked = (val: Record<string, boolean>) => {
      const [id] =
        (Object.entries(val).find(([, val]) => val) as [string, boolean]) || [];
      selected_info_types.value = val;
      if (id) {
        _value.value = {
          [id]: {
            // @ts-ignore
            type: "LABEL",
            id,
            name: SharedState.allInfoTypes.value[id].labelName,
          },
        };
        apply();
      }
    };
    const subscriptions = {
      esc: emptyFn(),
      checkEvent: emptyFn(),
    };

    watch(query, (new_q, old_q) => {
      if (old_q && isEmpty(new_q)) {
        emit("onSearchClear");
        // When clearing search for labels/context, defer tree re-render to avoid blocking
        if (
          (population.value === POPULATION_TYPE.LABEL || population.value === POPULATION_TYPE.CONTEXT) &&
          has_loaded_label_tree.value
        ) {
          is_tree_loading.value = true;
          run_when_idle(() => {
            is_tree_loading.value = false;
          });
        }
      }
    });

    const _value: Ref<{ [key: number]: ListItem }> = ref({});
    const resetValue = () => {
      _value.value = clone(props.value as ListItem[]).reduce((acc, val) => {
        acc[val.id as number] = val;
        return acc;
      }, {} as { [key: number]: ListItem });

      if (props.population === POPULATION_TYPE.LABEL) {
        if (!has_loaded_label_tree.value) {
          load_label_tree();
        }
      }
    };

    watch(population, (p: POPULATION_TYPE) => {
      changeEntity(p);
      resetValue();
      // unsub
      subscriptions.checkEvent();
      // sub to new population type
      subscriptions.checkEvent = EventBus.listen(
        "transfer-check-" + props.population,
        (payload: { item: ListItem; check: boolean }) => {
          onCheckedChange(payload.item, payload.check);
        }
      );

      if (p === POPULATION_TYPE.LABEL && !has_loaded_label_tree.value) {
        load_label_tree();
      }
    });

    // === INPUT ===
    const inputRef: Ref<null | HTMLInputElement> = ref(null);

    const onEsc = onKey("Escape");

    const clearInput = () => {
      query.value = "";
      (inputRef.value as HTMLInputElement).blur();
    };

    const onCheckedChange = (item: ListItem, isCheck: boolean) => {
      item.checked = isCheck;
      if (props.singleSelection) {
        _value.value = { [item.id]: item };
      } else {
        if (isCheck) {
          _value.value = { ..._value.value, [item.id]: item };
        } else {
          const c = clone(_value.value, true);
          delete c[item.id as number];
          _value.value = { ...c };
        }
      }
      apply();
    };

    const updatedDisplayItems = computed(() => {
      let list = displayItems.value.map((item) => {
        return {
          ...item,
          checked: _value.value[item.id as number] ? true : false,
        } as ListItem;
      });

      if (props.excludeFolderLabelType && population.value === POPULATION_TYPE.LABEL) {
        list = list.filter((item: any) => {
          const label = SharedState.allInfoTypes.value[item.id] as
            | { labelType?: string }
            | undefined;
          return !label || label.labelType !== "Folder";
        });
      }

      const is_contacts = population.value === POPULATION_TYPE.CONTACT;

      const is_searching_anonymous =
        isSearching &&
        query.value.length > 0 &&
        "anonymous user".search(query.value.toLowerCase()) > -1;

      const is_anonymous_user_set =
        isNotEmpty(SharedState.anonymousUserId.value) &&
        SharedState.anonymousUserId.value !== "anonymous-user";

      const add_anonymous_user =
        is_contacts && is_searching_anonymous && is_anonymous_user_set;

      return add_anonymous_user
        ? [
            {
              name: "Anonymous user",
              id: SharedState.anonymousUserId.value,
              type: POPULATION_TYPE.CONTACT,
              // @ts-ignore
              checked: _value.value[SharedState.anonymousUserId.value]
                ? true
                : false,
            },
            ...list,
          ]
        : list;
    });

    const apply = () => {
      console.log(_value.value);
      const val = Object.values(_value.value);
      emit("input", val);
      emit("onItemChecked", val);
    };

    onMounted(() => {
      resetValue();
      subscriptions.esc = onEsc((ev: KeyboardEvent) => {
        if (isSearching.value) {
          ev.stopImmediatePropagation();
          ev.stopPropagation();
          clearInput();
        }
      });
      subscriptions.checkEvent = EventBus.listen(
        "transfer-check-" + props.population,
        (payload: { item: ListItem; check: boolean }) => {
          onCheckedChange(payload.item, payload.check);
        }
      );
    });

    onBeforeUnmount(() => {
      Object.values(subscriptions).forEach((unsub) => unsub());
    });

    const isHuman = (type: POPULATION_TYPE) =>
      [
        POPULATION_TYPE.EMPLOYEE,
        POPULATION_TYPE.PRIVATE_EMAIL,
        POPULATION_TYPE.CONTACT,
      ].includes(type);

    const startsWithAEIOU = (word: string) =>
      ["a", "e", "i", "o", "u"].some((letter) => word.startsWith(letter));

    const searchImgPlaceHolder = computed(() => {
      const type = PopulationTypeHelper.asString(
        population.value
      ).toLowerCase();
      const prefix = startsWithAEIOU(type) ? "an" : "a";
      return `Search for ${prefix} <b class="text-lg">${type}</b><br />
          to investigate ${
            isHuman(population.value) ? "their" : "it's"
          } information behavior`;
    });

    return {
      _value,
      isSearching,
      inputRef,
      updatedDisplayItems,
      query,
      ListItemCmp,
      apply,
      isLoading,
      is_tree_loading,
      loadMoreItems,
      onCheckedChange,
      // placeholder,
      searchImgPlaceHolder,
      row_height,
      on_info_type_checked,
      local_info_types,
      selected_info_types,
    };
  },
});
